import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";
import type { FC } from "react";

type IconProps = Partial<SVGIconProps>;

const ChevronDownIcon: FC<IconProps> = (props) => (
  <SVGIcon viewBox="0 0 11 6" {...props}>
    <path
      clipRule="evenodd"
      d="M0.814415 0.811974C1.00968 0.616712 1.32626 0.616712 1.52152 0.811974L5.38345 4.6739C5.44854 4.73899 5.55407 4.73899 5.61915 4.6739L9.48108 0.811972C9.67634 0.61671 9.99293 0.61671 10.1882 0.811972C10.3835 1.00723 10.3835 1.32382 10.1882 1.51908L6.32626 5.38101C5.87065 5.83662 5.13196 5.83662 4.67634 5.38101L0.814415 1.51908C0.619153 1.32382 0.619153 1.00724 0.814415 0.811974Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </SVGIcon>
);

export default ChevronDownIcon;
